import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { batchSchedule } from '../../../actions/studio';
import { Props } from './ScheduleBatch';
import { AppState } from '../../../types/store';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchSchedule'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  batchSchedule,
};

export default connect(mapStateToProps, mapDispatchToProps);
